import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { HelmetProvider } from 'react-helmet-async';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }
  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }
  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: '40px 24px', fontFamily: 'sans-serif', textAlign: 'center', background: '#f3f4f6', minHeight: '100vh' }}>
          <div style={{ fontSize: '48px', marginBottom: '16px' }}>⚠️</div>
          <p style={{ fontWeight: 'bold', fontSize: '16px', marginBottom: '8px' }}>アプリの読み込みに失敗しました</p>
          <p style={{ fontSize: '13px', color: '#6b7280', marginBottom: '24px', wordBreak: 'break-all', padding: '8px 12px', background: '#fff', borderRadius: '8px', textAlign: 'left' }}>
            {String(this.state.error)}
          </p>
          <button
            onClick={() => window.location.reload()}
            style={{ padding: '12px 32px', fontSize: '15px', fontWeight: 'bold', backgroundColor: '#2563eb', color: '#fff', border: 'none', borderRadius: '24px', cursor: 'pointer' }}
          >
            再読み込み
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    </HelmetProvider>
  </React.StrictMode>
);

// Service Worker registration for PWA offline support
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(err => {
      console.warn('Service Worker registration failed:', err);
    });
  });
}
